/** Copyright (c) 2023-present ORBIS DS Authors. */

import {
	MAX_LENGTH_NEGATIVE_PROMPT,
	MAX_LENGTH_SEARCH,
	MAX_LENGTH_PROJECT_TITLE,
	MAX_PASS_LENGTH,
	MIN_LENGTH_PROJECT_TITLE,
	MAX_PIXEL_COUNT_NON_SDXL_MODELS,
	MAX_PIXEL_COUNT_SDXL_MODELS,
	MAX_PROMPT_TITLE_WORDS,
	MAX_PROMPT_TITLE_LENGTH,
	CREDITS_COST_ENHANCE,
	UPLOAD_MAX_SIZE_MB,
	UPLOAD_MAX_SIZE_PX,
} from './default';

const strings = {
	//
	signInBelowText: 'Sign in Below',
	signUpBelowText: 'Sign up Below',
	signUpSuccessfulText: 'Sign up Successful!',
	signInText: 'Sign In',
	signUpText: 'Sign up',
	signInHereText: 'sign in here',
	signUpHereText: 'sign up here',
	enterYourEmailAddressText: 'Enter your email address',
	continueWithDiscordText: 'Continue with Discord',
	discordNotConnected: 'Your Discord Account is not connected yet.',
	discordPleaseJoinPart1: 'Please ',
	discordPleaseJoinPart2: ' and then link accounts below',
	discordJoinServer: 'join our Discord server',
	forgotPassQuestionText: 'Forgot password?',
	loginLowerCaseText: 'login',
	resetPassText: 'Reset password',
	continueText: 'Continue',
	orText: 'or',
	orReturnToText: 'or return to',
	sendPassResetLinkText: 'Send password reset link',
	byClickingContinueYouAgreeText: 'By clicking "Continue" you agree to the',
	privacyPolicy: 'Privacy Policy',
	termsOfService: 'Terms of Service',
	repeatNewPassText: 'Repeat new password',
	goBackText: 'Go Back',
	passwordText: 'Password',
	repeatPassText: 'Repeat Password',
	rememberMeText: 'Remember me',
	stayTunedText: 'Stay tuned',
	signUpFailedText: 'Sign up Failed!',
	emailSentText: 'Email sent',
	emailNotFoundText: 'Email not found',
	changePassText: 'Change Password',
	emailVerificationFailedText: 'Email verification failed!',
	emailVerificationSuccessText: 'Email verification success!',
	signUpMessage:
		'A confirmation email was sent to your inbox. Click on the link inside to finish your registration.',

	// Banner
	bannerContent: 'Join our Discord server to create on mobile!',
	linkAccount: 'Link Account',
	joinServer: 'Join Server',

	// Messages
	loading: 'Loading...',
	imageLoadingFail: 'Image failed to load',

	// Toggle Buttons in Right sidebar
	t2iButtonLabel: 'Conjure',
	// i2iButtonLabel: 'Transform',

	// Right sidebar
	t2iText: 'Conjure',
	// i2iText: 'Transform',
	surpriseMeButtonLabel: 'Surprise me',

	// Buttons and Buttons' tooltips
	getInspiredTooltip: 'Get inspired',
	update: 'Update',
	cancel: 'Cancel',
	sourceImage: 'Use as source image',
	variations: 'Variations',
	sharpness: 'Sharpness',
	enhanceSharpness: 'Enhance Sharpness',
	upscale: 'Upscale',
	enhanceScaleFactor: 'Enhance Scale Factors',
	edit: 'Edit',
	download: 'Download',
	share: 'Share',
	removeFromLiked: 'Remove from liked',
	createNewProject: 'Create Project',
	yes: 'Yes',
	no: 'No',
	loadMore: 'Load More',
	home: 'Home',
	library: 'Library',
	history: 'History',
	projectHistory: 'Project History',
	favorites: 'Favorites',
	favoritedImages: 'Favorited Images',
	editLater: 'Edit Later',
	editLaterImages: 'Edit Later Images',
	help: 'Help',
	credits: 'credits',
	lessThan: 'less than',
	discord: 'Discord',
	thisProject: 'This Project',
	allProjects: 'All Projects',
	allImages: 'All Images',
	textToImage: 'Text to Image',
	imageToImage: 'Image Transformation',
	savedWithTitle: 'Already saved with title:',
	myProjects: 'My Projects',
	myLibrary: 'My Library',
	discover: 'Discover',
	deleteItem: 'Delete',
	deleteImage: 'Delete Image',
	likeImage: 'Add to Favorites',
	dislikeImage: 'Remove from Favorites',
	addImageToEditLater: 'Add to Edit Later',
	removeImageFromEditLater: 'Remove from Edit Later',
	downloadImageLabel: 'Download',
	shareImage: 'Share',
	editImage: 'Edit',
	upscaleImage: 'Upscale',
	imageUpscaled: 'Image already upscaled',
	variationsImage: 'Variations',
	buyCreditsButton: '	Buy Credits',
	generateFromTextBtnLabel: 'Conjure',
	generateFromImageBtnLabel: 'Transform',
	transform: 'Transform',
	enhance: 'Enhance',
	inPaint: 'InPaint',
	conjure: 'Conjure',
	reconjure: 'Reconjure',
	generating: 'Generating...',
	generateImages: 'Generate Images',
	providePrompt: 'Provide a Prompt',
	openInPaint: 'InPaint Mode',
	swapRatio: 'Swap Ratio',
	revertToSource: 'Revert to source size',
	upload: 'Upload',
	uploadAnother: 'Upload another',
	editSavedPrompt: 'Edit Saved Prompt',
	copyBtn: 'Copy',
	createCanvas: 'Create canvas',
	browse: 'Browse your Device',
	enabled: 'Enabled',
	disabled: 'Disabled',
	restoreDefaults: 'Restore defaults',
	btnSavePrompt: 'Save Prompt',
	btnDontSave: "Don't Save",
	btnRetry: 'Retry',
	tutorials: 'Tutorials',
	discoverTitle: 'Discover amazing images made with Arcana',
	openImagePreviewModal: 'Open image preview',
	doNotShow: "Don't show again",
	refine: 'Refine',
	fill: 'Fill',
	more: 'more',

	// Tooltips
	savePrompt: 'Save Prompt',
	copyPrompt: 'Copy Prompt Text',
	stylesInfo: 'Style:',
	modelInfo: 'Model:',
	none: 'None',
	comingSoon: 'Coming soon!',
	brush: 'Mask Brush',
	eraser: 'Mask Eraser',
	invert: 'Invert',
	sizeBrushEraser: 'Brush and Eraser Size',
	expand: 'Expand',
	erase: 'Erase',
	eraseTooltip: 'Erase',
	showMask: 'Show Mask',
	hideMask: 'Hide Mask',
	maskCurrentlyHidden: 'Mask Currently Hidden',
	undo: 'Undo',
	closeInPaint: 'Exit InPaint',
	disabledNSFW: 'Disabled due to NSFW',
	imagesLeftText: 'images left',
	transformationInfo: '% of original image transformed',
	transformation: 'Transformation',
	tooltipCreativity:
		'Degree of creative details added. Negative values adhere more to source image',
	sendTo: 'Send to',
	dimensions: 'Dimensions:',
	uploadImageToEnable: 'Upload an image to enable',
	infoResizeBefore: 'Upscale to given dimensions before enhancing',
	cfgTooltip: 'Level of strict adherence to the prompt',
	clipSkipTooltip: 'Level of literal interpretation per word in prompt',
	enhanceTooltip: 'Magically elevates and upscales your source image',
	original: 'Original',
	stylesLabel: 'Style(s)',
	tooltipInfluence: 'Amount of influence the tool has over the generated result',
	removeImage: 'Remove Image',
	showOriginalImage: 'Show original',
	showPreprocessedImage: 'Show pre-processed',
	collapse: 'Collapse',
	showFavorites: 'Show favorites',
	reconjureDisabledTooltip: 'You can only Reconjure images generated within the Conjure suite',

	// Profile Menu
	logoutText: 'Logout',
	profileSettings: 'Profile settings',
	security: 'Security',

	// Notifications
	promptCopied: 'Prompt copied to clipboard',
	promptAlreadySaved: 'Prompt Already Saved. Avoid Duplicates.',
	maximumStylesSelected: 'The maximum of two styles has been reached',
	removedArcanaAccount: 'Successfully deleted Arcana account!',

	// Labels
	ratioAndModels: 'Aspect Ratio & Models',
	labelNegativePrompt: 'Negative prompt',
	labelImageAdjustments: 'Image Adjustments',
	labelStyles: 'Styles',
	labelModels: 'Model',
	labelAspectRatio: 'Aspect Ratio',
	imageAdjustment: 'Output size',
	small: 'Small',
	medium: 'Medium',
	big: 'Big',
	availableModels: 'Available models',
	maskDoubleDots: 'Mask:',
	invertMaskText: 'Mask inverts inpainted area',
	invertMaskTextToolTip: 'InPaint everything except mask',
	labelSimpleModels: 'Model selection',
	parametersLabel: 'Parameters',
	cfgLabel: 'CFG',
	clipSkipLabel: 'Clip Skip',
	name: 'Name',
	optional: 'optional',
	simple: 'Simple',
	advanced: 'Advanced',
	fullprompt: 'Full prompt',
	scaleFactor: 'Scale factor',
	finalSize: 'Final size',
	optimizedFor: 'Optimized for',
	photoSoft: 'Photo Soft',
	photoHard: 'Photo Hard',
	illustrationSoft: 'Illustration Soft',
	illustrationHard: 'Illustration Hard',
	enhancements: 'Enhancements',
	creativity: 'Creativity',
	before: 'Source',
	after: 'Result',
	details: 'Details',
	resizeBefore: 'Resize before upscaling',
	labelWidth: 'Width',
	labeleHeight: 'Height',
	enhanceMaxImageSize: 'Max: 3000x3000px',
	enhanceLoading: 'Enhancing the image...',
	nsfwTutorialsSwitchLabel: 'Mature Content',
	optimizedForLabel: 'Optimized for:',
	creativityStrength: 'Creativity:',
	transformationStrength: 'Transformation strength:',
	labelEngine: 'Engine',
	labelSampler: 'Sampler',
	sharpnessLabel: 'Sharpness:',
	preProcessLabel: "Don't pre-process",
	preProcessTooltip: 'Pre-process tooltip',
	preProcessBtn: 'Pre-process image',
	influence: 'Influence',
	labelClearSelectedStyles: 'Clear all',

	// Messages
	noProjects: 'No Projects Available',
	noImages: 'No Images Available',
	noDiscordImages: "No Discord's Images Available",
	noTutorials: 'No Tutorials Available',
	noMatches: 'No matches',
	altProjectImage: 'Project leading image',
	altImage: 'AI-Generated Image',
	altProjectHistoryImage: 'Project history image',
	altGenerationImage: 'Generation image',
	savedPrompts: 'Saved Prompts',
	nsfwImage: 'NSFW Image',
	nsfwTextPart1: 'Go to',
	nsfwTextPart2: 'settings',
	nsfwTextPart3: '& verify your age',
	addStyles: 'Add Styles',
	oneStyleSelected: '1 Style Selected',
	stylesSelected: 'Styles Selected',
	welcomeText: 'Welcome to Arcana!',
	noProjectsBlockLabel: 'No Projects yet.',
	noProjectsBlockText: 'Start by creating your first project and generate amazing images.',
	shareImageTitle: 'Share this image',
	shareImageCopyLink: 'or copy link:',
	errorLoadingMoreAnnouncements: 'There was an error loading more announcements.',
	searchTutorialsPlaceHolder: 'Search :tutorialsCount tutorials',
	searchStylesPlaceHolder: 'Search styles',
	altTutorialThumb: 'Video Tutorial',
	noVideo: 'No Video Available',
	enhanceCost: `Enhance costs ${CREDITS_COST_ENHANCE} Credits`,
	uploadImageContainerMsg: 'Click to upload or drag & drop your image',
	// eslint-disable-next-line prettier/prettier
	uploadImageLimitation: `PNG, JPG · Max. size: ${UPLOAD_MAX_SIZE_PX}px combined height and width, or up to ${UPLOAD_MAX_SIZE_MB}Mb`,

	// Confirm messages
	confirmDeleteProject: 'Are you sure you want to delete this project?',
	confirmDeleteImage: 'Are you sure you want to delete this image?',

	// Validations
	matchPasswordString:
		'Password must contain at least one uppercase letter, one lowercase letter, and one symbol',
	pleaseEnterPass: 'Please enter a password',
	passMustMatch: 'Passwords must match',
	passMustBeLonger: `Password must be longer than ${MAX_PASS_LENGTH} symbols`,
	pleaseEnterEmail: 'Please enter an email',
	nameIsRequired: 'Name is required',
	pleaseEnterValidEmail: 'Please enter a valid email!',
	pleaseEnterName: 'Please enter a valid name!',
	theMinLengthName: 'The minimum length for a name is 2 characters.',
	theMaxLengthName: 'The maximum length for a name is 40 characters.',
	theMaxLengthDescription: 'The maximum length for a description is 250 characters.',
	cannotBeEmpty: 'Cannot be empty!',
	hasSpecialChars: 'Input contains special characters',
	maxCharsNegativePrompt: `Text should not exceed ${MAX_LENGTH_NEGATIVE_PROMPT} characters.`,
	maxCharsSearch: `${MAX_LENGTH_SEARCH} character limit on searches`,
	maxPromptTitleWords: `The maximum number of words ${MAX_PROMPT_TITLE_WORDS} exceeded`,
	maxPromptTitleLength: `The maximum of ${MAX_PROMPT_TITLE_LENGTH} chars exceeded`,
	minCharsProjectTitle: `Minimum ${MIN_LENGTH_PROJECT_TITLE}!`,
	maxCharsProjectTitle: `Max length is ${MAX_LENGTH_PROJECT_TITLE}!`,
	imageDimensionConstraintSDXL: `Whoops! This model cannot have a height and width exceed ${MAX_PIXEL_COUNT_SDXL_MODELS} pixels`,
	imageDimensionConstraintNonSDXL: `Whoops! This model cannot have a height and width exceed ${MAX_PIXEL_COUNT_NON_SDXL_MODELS} pixels`,
	uploadImageFailed: 'Upload image failed',
	uploadImageInvalidType: 'Invalid file type. Please choose a JPEG or PNG file.',
	uploadImageFileSize:
		// eslint-disable-next-line max-len
		`Your image exceeds ${UPLOAD_MAX_SIZE_PX}px in combined height and width, or your image is larger than ${UPLOAD_MAX_SIZE_MB}Mb. Please upload a smaller image.`,
	uploadImageFileSizeAvatar:
		// eslint-disable-next-line max-len
		`The file must not be greater than ${UPLOAD_MAX_SIZE_MB}MB. Please upload a smaller image.`,
	uploadImageDifferentTypeAvatar:
		// eslint-disable-next-line max-len
		`Invalid file type. Please upload again.`,

	// Placeholders
	placeholderPromptDefault: 'What do you want to create?',
	placeholderPromptI2I: 'Enter the change you want to see',
	placeholderPromptEnhance: 'Describe your image (optional)',
	placeholderNegativePrompt: "What don't you want to see?",

	// Profile
	updatePassword: 'Update password',
	repeatPassword: 'Repeat password',
	currentPassword: 'Current password',
	newPassword: 'New password',
	uploadImage: 'Upload image',
	deleteProfile: 'Delete Profile',
	currentPassCannotBeSame: 'Current password cannot be the same as the new password.',
	newPassDontMatch: `New password and repeat password don't match.`,
	saveChanges: `Save changes`,
	tellUsAboutYourself: `Tell us about yourself`,
	recommended: `Recommended`,
	emailAddress: `Email Address`,
	unlink: `Unlink`,
	linkDiscord: `Link Discord`,
	resetSettings: `Reset Settings`,
	confirmDeleteProfileTitle: 'Delete Your Profile?',
	confirmDeleteProfileContent:
		'When you delete your Arcana profile, all associated data will be deleted permanently. This action cannot be undone.',
	confirmDeleteProfileYesBtn: 'Yes, delete my profile forever',
	confirmDeleteProfileNoBtn: 'Back to profile',
	profilePageTitle: 'Artist Profile',
	nsfwLabel: 'NSFW Blocker',

	// Credits modal and page
	creditsLeft: 'You have :credits Credits left',
	imagesLeftMessage:
		'Hey! You only have :imagesLeft images left to conjure. Good news is monthly credits replenish for all users!',
	productsOptions: ` If you don't want to wait, see your options below:`,
	creditsCount: 'credits',
	exclTax: 'excl. tax',
	creditsPageTitle: 'Continue enjoying Arcana',
	freeCredits: 'Free credits',
	alreadyRedeemed: 'already redeemed.',
	redeemCredits: 'Redeem',
	forFree: 'for free.',
	successCreditsRedeem: 'Great! Credits redeemed! You have :creditsRedeem credits more.',
	errorCreditsRedeem: 'Unable to redeem credits!',

	// dialog titles
	// TODO_NEXT rename 'dialogTitle...'
	deleteProjectTitle: 'Delete project',
	deleteImageTitle: 'Delete image',
	ageVerificationTitle: 'Age verification',
	dialogTitleSavePrompt: 'Save prompt',
	dialogTitleRenameSavedPrompt: 'Re-Name Prompt',

	uploadFailed: 'Upload failed',
	invalidFileType: 'Invalid file type',
	imageToLarge: 'Image too large',

	// mobile view
	mobileViewText1: 'Our web experience is optimized for desktop',
	mobileViewText2: 'For better experience',
	continueToDiscord: 'Continue to Discord',
	goToWebVersion: 'Go to Web Version',

	// Help menu
	contactUs: 'Contact Us',
	faq: 'FAQs',
	helpCenter: 'Help Center',
};

export default strings;
